import { FEATURE_TOGGLES, useFeatureToggle } from 'sharedComponents/FeatureToggle';

const useMultiScreen = () => {
  return useFeatureToggle(FEATURE_TOGGLES.MULTI_SCREEN);
};

export default useMultiScreen;
